import { isEmpty } from 'ramda';

export default isEmpty;
